import React, { useState, useEffect, useContext } from "react";
import {
  Grid,
  Dialog,
  IconButton,
  Typography,
  makeStyles,
  withStyles,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";

import InputLabel from "@material-ui/core/InputLabel";
import LoadingIndicator from "../../../../Component/LoadingIndicator";
import ModalDialogContext from "../../../../Context/ModalDialog/ModalDialogContext";

import styles from "./styles";
import { getListValues } from "../../../../API/List";
import { useTranslation } from "react-i18next";
import CustomButton from "../../../../Component/CustomButton";

const useStyles = makeStyles(styles);

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const ViewAddress = (props) => {
  const { open, onclose, address } = props;
  const classes = useStyles();
  const [isDialogOpen, setIsDialogOpen] = useState(open);
  const [addressType, setAddressType] = useState();
  const [addressLine1, setAddressLine1] = useState("");
  const [addressLine2, setAddressLine2] = useState();
  const [addressLine3, setAddressLine3] = useState();
  const [addressLine4, setAddressLine4] = useState();
  const [region, setRegion] = useState();
  const [town, setTown] = useState();
  const [postCode, setPostCode] = useState();
  const [selectedCountry, setSelectedCountry] = useState();

  const [isLoading, setIsLoading] = useState(false);

  const { t } = useTranslation();

  useEffect(() => {
    if (open) {
      processAddressData();
    }
  }, [open]);

  const handleClose = () => {
    setIsDialogOpen(false);
    setAddressLine1();
    setAddressLine2();
    setAddressLine3();
    setAddressLine4();
    setRegion();
    setPostCode();
    setTown();
    setSelectedCountry();
    setAddressType();
    if (onclose) {
      onclose("cancel");
    }
  };

  const renderLoadingIndicator = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          // height: "70vh",
        }}
      >
        <LoadingIndicator />
      </div>
    );
  };

  const processAddressData = async () => {
    setIsDialogOpen(true);
    setIsLoading(true);
    const {
      jll_region,
      postcode,
      country_name,
      address_line_1,
      address_line_2,
      address_line_3,
      address_line_4,
      address_type,
      city,
    } = address;

    setAddressLine1(address_line_1);
    setAddressLine2(address_line_2);
    setAddressLine3(address_line_3);
    setAddressLine4(address_line_4);
    setRegion(jll_region);
    setPostCode(postcode);
    setTown(city);
    setSelectedCountry(country_name);
    setAddressType(address_type);
    setIsLoading(false);
  };

  const renderViewForm = () => {
    return (
      <Grid container direction="row" spacing={3}>
        <Grid item sm={6} md={6} xs={12} className={classes.recordOnTop}>
          <InputLabel className={classes.inputLabel}>{t("labels.record.addresses.form.addressType")}</InputLabel>
          <span> {addressType ? addressType : "-"}</span>
        </Grid>
        <Grid item sm={6} md={6} xs={12} className={classes.recordOnTop}>
          <InputLabel className={classes.inputLabel}>{t("labels.record.addresses.form.addressLine1")}</InputLabel>
          <span> {addressLine1 ? addressLine1 : "-"}</span>
        </Grid>
        <Grid item sm={6} md={6} xs={12}>
          <InputLabel className={classes.inputLabel}>{t("labels.record.addresses.form.addressLine2")}</InputLabel>
          <span> {addressLine2 ? addressLine2 : "-"}</span>
        </Grid>
        <Grid item sm={6} md={6} xs={12}>
          <InputLabel className={classes.inputLabel}>{t("labels.record.addresses.form.addressLine3")}</InputLabel>
          <span> {addressLine3 ? addressLine3 : "-"}</span>
        </Grid>
        <Grid item sm={6} md={6} xs={12}>
          <InputLabel className={classes.inputLabel}>{t("labels.record.addresses.form.addressLine4")}</InputLabel>
          <span> {addressLine4 ? addressLine4 : "-"}</span>
        </Grid>

        <Grid item sm={6} md={3} xs={12}>
          <InputLabel className={classes.inputLabel}>{t("labels.record.addresses.form.region")}</InputLabel>
          <span> {region ? region : "-"}</span>
        </Grid>

        <Grid item sm={6} md={3} xs={12}>
          <InputLabel className={classes.inputLabel}>{t("labels.record.addresses.form.city")}</InputLabel>
          <span> {town ? town : "-"}</span>
        </Grid>
        <Grid item sm={6} md={3} xs={12} className={classes.selectOnTop}>
          <InputLabel className={classes.inputLabel}>{t("labels.record.addresses.form.country")}</InputLabel>
          <span> {selectedCountry ? selectedCountry : "-"}</span>
        </Grid>
        <Grid item sm={6} md={3} xs={12}>
          <InputLabel className={classes.inputLabel}>{t("labels.record.addresses.form.postCode")}</InputLabel>
          <span> {postCode ? postCode : "-"}</span>
        </Grid>
      </Grid>
    );
  };

  return (
    <>
      <Dialog
        disableBackdropClick
        onClose={handleClose}
        aria-labelledby="add-document-modal"
        open={isDialogOpen}
        fullWidth={true}
        maxWidth="md"
      >
        <DialogTitle id="add-document-modal" onClose={handleClose}>
          <Typography className={classes.panelTitle}>{t("labels.record.addresses.viewAddress")}</Typography>
        </DialogTitle>
        <DialogContent dividers>
          {isLoading ? renderLoadingIndicator() : renderViewForm()}
        </DialogContent>

        <DialogActions>
          <CustomButton 
            variant="secondary" 
            onClick={handleClose}
          >
            {t("labels.common.close")}
          </CustomButton>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ViewAddress;
